import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import MultiPartFields from './AsyncMultiPart';

const MultiPartQuestion = props => {
  return (
    <QuestionWrapper {...props}>
      <MultiPartFields {...props} />
    </QuestionWrapper>
  );
};

MultiPartQuestion.propTypes = {
  composite_type: PropTypes.oneOf(['us_address', 'address', 'age', 'phone']),
  required: PropTypes.bool,
  text: PropTypes.string,
};

export default MultiPartQuestion;
